import React from "react";
import arrowRight from "../../assets/icons/arrow-right-purple.svg";

export default function BoardColumnCollapsed({ setCollapsedBoards, board }) {
  return (
    <div className="left-bar">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 50 }}>
        <div
          style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.1)", padding: 3, borderRadius: 7 }}
          onClick={() => setCollapsedBoards((prevBoards) => prevBoards.filter((prevBoard) => prevBoard !== board.id))}
        >
          <img src={arrowRight} alt="right arrow" className="mouse-hover" />
        </div>

        <span className="text-rotate" style={{ color: "#6B43B5" }}>
          1234 Patients
        </span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 80, marginBottom: 35 }}>
        <span
          className="text-rotate"
          style={{ backgroundColor: "#EEEDFA", color: "#6B43B5", padding: "3px 10px", borderRadius: 100, fontSize: 12, textTransform: "capitalize" }}
        >
          {board.type}
        </span>

        <p style={{ marginBottom: 0, fontSize: 16, fontWeight: "bold" }} className="text-rotate">
          {board.name}
        </p>
      </div>
    </div>
  );
}
